<template>
  <div>
    <div class="mt-1 mb-2" :class="pathMixin_isMeeting ? 'box' : ''">
      <FlightFilters
        v-model="filters"
        :filterOptions="filterOptions"
        :preferredChains="preferredVendors"
        :highlights="highlightedFilters"
        :sortOptions="sortOptions"
        :unusedTickets="unusedTickets"
        :tripVal="tripVal"
        @clearFilters="defaultFilters()"
        @resetFilter="resetFilter"
      />
    </div>

    <!-- INFO ICONS -->
    <div class="mt-5 mb-2 pb-1 is-flex is-justify-content-center">
      <span class="ml-2 mr-2">
        <b-icon icon="currency-usd" size="is-small" type="is-info"></b-icon>
        <span class="is-size-7 has-text-grey" style="margin-left: -5px;">
          = Unused Ticket Available</span
        >
      </span>
      <span class="ml-2 mr-2" v-if="isOneWay">
        <b-icon
          icon="alpha-f-circle"
          size="is-default"
          class="has-text-grey-lighter"
        />
        <span class="is-size-7 has-text-grey">Fare Rules</span>
      </span>
      <!--        <span class="ml-2 mr-2">-->
      <!--          <b-icon-->
      <!--                  icon="information"-->
      <!--                  size="is-default"-->
      <!--                  class="has-text-grey-lighter"-->
      <!--              />-->
      <!--          <span class="is-size-7 has-text-grey">Flight Details</span>-->
      <!--        </span>-->
    </div>

    <!--  HEADERS -->
    <div
      class="columns is-mobile is-gapless mb-0 pr-1 filters-container is-hidden-touch"
    >
      <!-- AIRLINE LOGO -->
      <div class="column is-narrow has-text-centered wrap">
        <div class="mt-1 airlineLogo"></div>
      </div>
      <!-- FROM-TO -->
      <div class="column is-narrow" style="width:135px">
        <span class="sbs-table-header">From-To</span>
      </div>
      <!-- DEPARTURE-ARRIVAl -->
      <div class="column">
        <span class="sbs-table-header">Departure-Arrival</span>
      </div>
      <!-- DURATION -->
      <div class="column is-narrow has-text-centered" style="width:140px;">
        <span class="sbs-table-header">Duration & Stops</span>
      </div>
      <!-- UNUSED TICKET -->
      <div class="column has-text-centered is-narrow" style="width:40px;">
        <span class="sbs-table-header" v-if="$globals.ticketAirlines.length > 0"
          >$</span
        >
      </div>
      <!-- OUT OF POLICY -->
      <!-- <div class="column has-text-centered is-narrow" style="width:80px;">
        <span class="sbs-table-header"> Travel Policy </span>
      </div> -->
      <!-- PRICE RANGE -->
      <div
        class="column is-narrow mr-2"
        :class="isOneWay ? 'has-text-right' : 'has-text-centered'"
        :style="isOneWay ? 'width:80px;' : 'width:120px;'"
      >
        <span class="sbs-table-header ml-3">Price</span>
      </div>
      <!-- FARE RULES (One-Way Only) -->
      <div
        class="column is-narrow has-text-left"
        v-if="isOneWay"
        :style="isOneWay ? 'width:75px;' : 'width:40px;'"
      >
        <span class="sbs-table-header">
          Fare
        </span>
      </div>
      <!-- FLIGHT INFO -->
      <div class="column is-narrow" style="width: 100px;"></div>
      <!-- SELECT/DESELECT BUTTONS -->
      <div class="column is-narrow mr-2" style="width: 70px;"></div>
    </div>

    <div v-if="sortedFilteredItems.length == 0" style="text-align: center;">
      <b-message type="is-danger">
        No results found. <br />
        <br />
        Try removing some filters to see more results <br />
        <br />
        <b-button @click="defaultFilters" type="is-primary is-small"
          >Restore defaults</b-button
        >
      </b-message>
    </div>

    <div
      v-else
      class="flightResultsContainer"
      data-test="price_results_container"
    >
      <div
        v-for="(item, index) in sortedFilteredItems.slice(0, numVisibleResults)"
        :key="index"
        
      >
        <PriceResult
          :searchDetails="searchDetails"
          :preferredVendors="preferredVendors"
          :tripVal="tripVal"
          :solution="item"
          @filter="filterByFlight"
          data-test="search_by_price_item"
          
        />
      </div>

      <!--
      <RecycleScroller
        page-mode
        class="scroller"
        :items="sortedFilteredItems.slice(0, numVisibleResults)"
        :item-size="120"
        key-field="uniqueKey"
        v-slot="{ item }"
      >
        <PriceResult
          :searchDetails="searchDetails"
          :preferredVendors="preferredVendors"
          :tripVal="tripVal"
          :solution="item"
          @filter="filterByFlight"
        />
      </RecycleScroller>

      
      <DynamicScroller
        page-mode
        :items="sortedFilteredItems.slice(0, numVisibleResults)"
        :min-item-size="101"
        :buffer="800"
        class="scroller"
        key-field="uniqueKey"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :data-index="index"
            data-test="search_by_price_item"
            :data-id="item.id"
          >
            <PriceResult
              :searchDetails="searchDetails"
              :preferredVendors="preferredVendors"
              :tripVal="tripVal"
              :solution="item"
              @filter="filterByFlight"
            />
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>

      -->

      <div class="has-text-centered">
        <b-button
          v-if="numVisibleResults < filteredItems.length"
          outlined
          
          type="is-info"
          size="is-medium"
          class="mt-4"
          @click="numVisibleResults += pageSize"
          >Show more results</b-button
        >
      </div>

      <!-- MORE RESULTS LOADER BELOW -->

      <div v-if="filters.selectedAirlines.length > 0">
        <div class="" style="border: 10px solid #E6E6E6;"></div>

        <div
          v-if="flightSearchLoadingStatus == false"
          class="is-flex is-justify-content-center pl-2 pr-2"
        >
          <div
            class="mt-1 mb-2 is-centered"
            :class="pathMixin_isMeeting ? 'box' : ''"
          >
            <div class="is-size-6 mb-4 is-centered" style="text-align: center">
              Looking for more flight options? <br />Search for more specific
              flights on these airlines:
            </div>

            <FlightFilters
              v-model="filters"
              :filterOptions="moreResultsFilterOptions"
              :highlights="highlightedFilters"
              :sortOptions="[]"
              :unusedTickets="[]"
              :tripVal="tripVal"
              @clearFilters="defaultFilters()"
              @resetFilter="resetFilter"
            />

            <div class="mt-4 is-flex is-justify-content-center">
              <div
                class="button is-rounded is-primary "
                @click="searchTargetedAirlines(filters.selectedAirlines)"
              >
                Search for matching flights
                <span class="icon is-right ml-4"
                  ><i class="mdi mdi-airplane-takeoff mdi-24px"></i
                ></span>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-1 pb-2 pr-0" v-if="flightSearchLoadingStatus === true">
          <div class="has-text-centered p-6">
            <span class="gant-text"
              >Please wait while we're searching for additional flights.
            </span>
            <ReloadIcon style="width: 30px;" />
          </div>
        </div>
      </div>

      <!-- END MORE RESULTS LOADER -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ToastProgrammatic as Toast } from "buefy";
import FlightFilters from "@/components/Filters/FlightFilters.vue";
import bookingMixin from "@/mixins/bookingMixin";
import meetingMixin from "@/mixins/meetingsMixin";
import flightFilterMixin from "@/mixins/flightFilterMixin";
import PriceResult from "@/components/BookTravel/Air/PriceResult";
import { mapState } from "vuex";
import {
  RecycleScroller,
  DynamicScroller,
  DynamicScrollerItem,
} from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

export default {
  name: "ResultsByPrice",
  mixins: [bookingMixin, meetingMixin, flightFilterMixin],
  props: {
    items: Array,
    formData: Object,
  },
  components: {
    FlightFilters,
    PriceResult,
    //RecycleScroller,
    //DynamicScroller,
    //DynamicScrollerItem,
  },
  data: function() {
    return {
      numVisibleResults: 20,
      pageSize: 20,
      loading: true,
      no_results: false,
      policyOnly: false,
      display_search: false,
      results_loaded: 200,
      flightNum: false,
      searchDetails: null,
    };
  },

  computed: {
    ...mapState(["bookTravel"]),
    ...mapState(["travellersAndTrips"]),

    //provide the data that contains available choices for each filter
    //can set an item to null to remove filter from display
    filterOptions() {
      return {
        allAirlines: this.getAirlines(this.items), //airlines filter
        filteredAirlines: this.getAirlines(this.filterItems("airline")), //airlines filter
        unusedTickets: this.unusedTickets, //unused tickets filter
        stops: this.buildStopsOptions(), //stops filter
        times: this.buildTimesOptions(), //time of day filter
        priceData: this.priceData, //price filter
        availablePolicies: this.availablePolicies, //policy filter
        highestRating: this.highestRating, //rating filter
      };
    },

    //filter options for the More Results loader
    moreResultsFilterOptions() {
      return {
        allAirlines: this.getAirlines(this.items),
        filteredAirlines: this.getAirlines(this.filterItems("airline")), //airlines filter
        unusedTickets: null,
        stops: null,
        tripVal: this.tripVal,
        priceData: null,
        availablePolicies: null,
        highestRating: null,
      };
    },

    // FILTER OPTIONS

    highestRating() {
      return this.getHighestRating(this.filteredItems);
    },
    availablePolicies() {
      return this.getPolicies(this.filteredItems);
    },

    unusedTickets() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].unusedTicketAirlines;
    },

    sortOptions() {
      let options = [];
      if (this.tripVal == "0") {
        options = [
          { value: "Rating", label: "Rating" },
          {
            value: "Time of day - Outbound",
            label: "Departure Time (outbound)",
          },
          { value: "Price Asc", label: "Price (Low to High)" },
          { value: "Price Desc", label: "Price (High to Low)" },
          { value: "Duration", label: "Duration" },
        ];
      } else if (this.tripVal == "1") {
        options = [
          { value: "Rating", label: "Rating" },
          {
            value: "Time of day - Outbound",
            label: "Departure Time (outbound)",
          },
          { value: "Time of day - Return", label: "Departure Time (return)" },
          { value: "Price Asc", label: "Price (Low to High)" },
          { value: "Price Desc", label: "Price (High to Low)" },
          { value: "Duration", label: "Duration" },
        ];
      } else {
        options = [
          { value: "Rating", label: "Rating" },
          { value: "Price Asc", label: "Price (Low to High)" },
          { value: "Price Desc", label: "Price (High to Low)" },
          { value: "Duration", label: "Duration" },
        ];
      }

      if (this.preferredVendors.length > 0) {
        options.push({
          value: "Preferred Vendors",
          label: "Preferred Airlines",
        });
      }

      return options;
    },

    sortedFilteredItems() {
      let sortedItems = this.sortItems(this.filteredItems);

      return sortedItems;
    },

    filteredItems() {
      return this.filterItems();
    },

    startDate() {
      return this.flightDetailsAlt.startDate.date;
    },
    endDate() {
      return this.flightDetailsAlt.endDate.date;
    },
    startTime() {
      // console.log('checking on startTime', this.flightDetailsAlt.depTime);
      return this.flightDetailsAlt.depTime;
    },
    endTime() {
      return this.flightDetailsAlt.arrTime;
    },

    tripVal() {
      return this.formData.tripVal;
    },
    flightSearchLoadingStatus() {
      return this.$store.state.bookTravel.flightSearchLoadingStatus;
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    preferredVendors() {
      return this.profile.preferredAirVendors || [];
    },
  },
  methods: {
    //Build array of options for "Stops" dropdown for a specified segment (i.e. outbound = 0 and return = 1)
    getStopsForSegment(segment) {
      let items = this.items;
      let layoverCounts = [];
      let array = [
        {
          value: "",
          label: "Any",
          count: 0,
        },
      ];

      for (let item of items) {
        let stops = item.journeys[segment].legs.length - 1;

        if (layoverCounts[stops] === undefined) {
          layoverCounts[stops] = 1;
        } else {
          layoverCounts[stops]++;
        }
      }

      // Sort low to high
      layoverCounts = Object.keys(layoverCounts).sort();

      // Build options list
      for (let stops of layoverCounts) {
        let option = {
          value: Number(stops),
          label: this.$helpers.stopsLabels(stops),
          count: Number(layoverCounts[stops]),
        };
        array.push(option);
      }

      return array;
    },
    //Build the array of options for the Stops filter
    //Each object represents one segment (e.g. 0 = outbound or 1 - return)
    buildStopsOptions() {
      let options = [];
      if (this.tripVal == this.TRIP_ONE_WAY) {
        options = [{ name: "", options: this.getStopsForSegment(0) }];
      } else if (this.tripVal == this.TRIP_ROUNDTRIP) {
        options = [
          { name: "Outbound Flight", options: this.getStopsForSegment(0) },
          { name: "Return Flight", options: this.getStopsForSegment(1) },
        ];
      }

      return options;
    },
    //Build the array of options for the Times filter
    //Each object represents one segment (e.g. outbound or return)
    buildTimesOptions() {
      let options = [];
      if (this.tripVal == this.TRIP_ONE_WAY) {
        options = [{ name: "" }];
      } else if (this.tripVal == this.TRIP_ROUNDTRIP) {
        options = [{ name: "Outbound" }, { name: "Return" }];
      }

      return options;
    },

    getAirlines(items) {
      let distinctAirlines = [];
      let sortedAirlines = [];

      for (let item of items) {
        let airlineCode = item.airlineCode;

        if (distinctAirlines[airlineCode] === undefined) {
          distinctAirlines[airlineCode] = 1;
        } else {
          distinctAirlines[airlineCode]++;
        }
      }

      // Sort airline codes A-Z
      let sortedAirlineKeys = Object.keys(distinctAirlines).sort();

      // Build sorted list
      for (let key of sortedAirlineKeys) {
        let airline = {
          code: key,
          resultsCount: distinctAirlines[key],
        };
        sortedAirlines.push(airline);
      }

      return sortedAirlines;
    },

    getHighestRating(items) {
      let rating = 0;

      if (items) {
        if (items.length) {
          for (let i = 0; i < items.length; i++) {
            if (rating < items[i].score) {
              rating = items[i].score;
            }
          }
        }
      }
      return rating;
    },

    getPolicies(items) {
      let policies = {};
      if (items) {
        if (items.length) {
          for (let i = 0; i < items.length; i++) {
            if (
              items[i].travelPolicy &&
              items[i].travelPolicy.summary.rulesTriggeredCount == 0
            ) {
              policies.none = true;
              policies.soft = true;
              break;
            } else if (
              items[i].travelPolicy &&
              items[i].travelPolicy.summary.hardApprovalRequiredCount == 0
            ) {
              policies.soft = true;
            }
          }
        }
      }
      return policies;
    },

    //Apply the filter option to the flight results
    filterItems(ignore = null) {
      {
        let items = this.items;
        if (items) {
          if (this.flightNum) {
            items = items.filter((i) => {
              return (
                i.journeys[this.flightNum["journey"]].legs[
                  this.flightNum["segment"]
                ].flightNumber == this.flightNum["flightNum"]
              );
            });
          }
          if (
            this.filters.maxStopsSegment1 ||
            this.filters.maxStopsSegment1 === 0
          ) {
            items = items.filter((i) => {
              return (
                i.journeys[0].legs.length - 1 <= this.filters.maxStopsSegment1
              );
            });
          }
          if (
            this.filters.maxStopsSegment2 ||
            this.filters.maxStopsSegment2 === 0
          ) {
            items = items.filter((i) => {
              return (
                i.journeys[1].legs.length - 1 <= this.filters.maxStopsSegment2
              );
            });
          }
          /* items = items.filter((i) => {
              return i.pricing.total <= 1500;
            }); */

          if (
            this.filters.minPrice !== this.minPrice ||
            this.filters.maxPrice !== this.maxPrice
          ) {
            items = items.filter((i) => {
              return i.pricing.total <= this.filters.maxPrice;
            });
            items = items.filter((i) => {
              return i.pricing.total >= this.filters.minPrice;
            });
          }

          if (this.filters.minRating) {
            items = items.filter((i) => {
              return i.score >= this.filters.minRating;
            });
          }

          if (this.filters.minPolicy) {
            if (this.filters.minPolicy == 1) {
              items = items.filter((i) => {
                return i.travelPolicy.summary.rulesTriggeredCount == 0;
              });
            } else if (this.filters.minPolicy == 2) {
              items = items.filter((i) => {
                return i.travelPolicy.summary.hardApprovalRequiredCount == 0;
              });
            }
          }

          if (this.filters.unusedTicketsOnly) {
            items = items.filter((i) => {
              return this.unusedTickets.includes(i.airlineCode);
            });
          }

          // if(this.policyOnly) {
          //   items = items.filter((i) => {
          //     return (i.travelPolicy.summary.rulesTriggeredCount == 0);
          //   });
          // }

          if (this.filters.timeRangeSegment1.segment == this.DEPARTURE_TIME) {
            items = items.filter((i) => {
              var date = new Date(
                i.journeys[0].legs[0].departingAt.date +
                  "T" +
                  i.journeys[0].legs[0].departingAt.time
              );
              return (
                date.getHours() >= this.filters.timeRangeSegment1.range[0] &&
                date.getHours() <= this.filters.timeRangeSegment1.range[1]
              );
            });
          }

          if (this.filters.timeRangeSegment1.segment == this.ARRIVAL_TIME) {
            items = items.filter((i) => {
              var date = new Date(
                i.journeys[0].legs.slice(-1).pop().arrivingAt.date +
                  "T" +
                  i.journeys[0].legs.slice(-1).pop().arrivingAt.time
              );
              return (
                date.getHours() >= this.filters.timeRangeSegment1.range[0] &&
                date.getHours() <= this.filters.timeRangeSegment1.range[1]
              );
            });
          }

          if (this.tripVal === this.TRIP_ROUNDTRIP) {
            if (
              this.filters.timeRangeSegment2 &&
              this.filters.timeRangeSegment2.range[1] &&
              this.filters.timeRangeSegment2.segment == this.DEPARTURE_TIME
            ) {
              items = items.filter((i) => {
                if (i.journeys[1].legs.length > 0) {
                  var date = new Date(
                    i.journeys[1].legs[0].departingAt.date +
                      "T" +
                      i.journeys[1].legs[0].departingAt.time
                  );
                  return (
                    date.getHours() >=
                      this.filters.timeRangeSegment2.range[0] &&
                    date.getHours() <= this.filters.timeRangeSegment2.range[1]
                  );
                }
              });
            }

            if (
              this.filters.timeRangeSegment2 &&
              this.filters.timeRangeSegment2.range[1] &&
              this.filters.timeRangeSegment2.segment == this.ARRIVAL_TIME
            ) {
              items = items.filter((i) => {
                if (i.journeys[1].legs[0]) {
                  var date = new Date(
                    i.journeys[1].legs.slice(-1).pop().arrivingAt.date +
                      "T" +
                      i.journeys[1].legs.slice(-1).pop().arrivingAt.time
                  );
                  return (
                    date.getHours() >=
                      this.filters.timeRangeSegment2.range[0] &&
                    date.getHours() <= this.filters.timeRangeSegment2.range[1]
                  );
                }
              });
            }
          }

          // apply airline filter unless ignore flag is set
          if (this.filters.selectedAirlines.length > 0 && ignore != "airline") {
            items = items.filter((i) => {
              let selectedAirlineCodes = this.filters.selectedAirlines.map(
                (a) => a.code
              );
              if (selectedAirlineCodes.includes(i.journeys[0].airlineCode)) {
                return true;
              }
            });
          }

          return items;
        }
      }
    },

    sortItems(sortedItems) {
      if (this.filters.sortOrder === "Rating") {
        sortedItems.sort((a, b) => {
          return b.score - a.score;
        });
      } else if (this.filters.sortOrder === "Time of day - Outbound") {
        sortedItems.sort((a, b) => {
          var aDate = new Date(
            a.journeys[0].startDate + " " + a.journeys[0].startTime
          );
          var bDate = new Date(
            b.journeys[0].startDate + " " + b.journeys[0].startTime
          );
          return aDate - bDate;
        });
      } else if (this.filters.sortOrder === "Time of day - Return") {
        sortedItems.sort((a, b) => {
          var aDate = new Date(
            a.journeys[1].startDate + " " + a.journeys[1].startTime
          );
          var bDate = new Date(
            b.journeys[1].startDate + " " + b.journeys[1].startTime
          );
          return aDate - bDate;
        });
      } else if (this.filters.sortOrder === "Price Asc") {
        sortedItems.sort((a, b) => {
          return a.pricing.total - b.pricing.total;
        });
      } else if (this.filters.sortOrder === "Price Desc") {
        sortedItems.sort((a, b) => {
          return b.pricing.total - a.pricing.total;
        });
      } else if (this.filters.sortOrder == "Preferred Vendors") {
        sortedItems.sort((a, b) => {
          return this.preferredVendors.includes(a.airlineCode)
            ? -1
            : this.preferredVendors.includes(b.airlineCode)
            ? 1
            : 0;
        });
      } else {
        sortedItems.sort((a, b) => {
          // return a.journeys[0].travelDuration - b.journeys[0].travelDuration
          let a_tot = 0;
          let b_tot = 0;
          for (var i = 0; i < a.journeys.length; i++) {
            a_tot += a.journeys[i].travelDuration;
            b_tot += b.journeys[i].travelDuration;
          }
          return a_tot - b_tot;
        });
      }

      return sortedItems;
    },

    filterByFlight(val) {
      this.flightNum = val;
      // console.log(this.flightNum)
    },

    searchTargetedAirlines(targetedAirlines) {
      this.$emit("searchTargetedAirlines", targetedAirlines);
    },

    selectAll() {
      this.filters.selectedAirlines = this.availableAirlines;
    },
    clearAll() {
      this.filters.selectedAirlines = [];
    },
    loadMore() {
      this.results_loaded += 10;
    },

    addFiltersBasedOnMeetingDates() {
      // tweak this based on new code coming from HuddleLabs
      // console.log('meeting stuff from addFiltersBasedOnMeetingDates', this.meetingInfo);
      // check if flight dates are the same ones that are restricted
      if (
        this.meetingInfo.meeting.latestArrival.date ===
        moment(this.startDate).format("YYYY-MM-DD")
      ) {
        // console.log('arriving on meeting start date');
        if (this.meetingInfo.meeting.latestArrival.time !== null) {
          // format time
          let formattedTime = this.meetingInfo.meeting.latestArrival.time;
          formattedTime = formattedTime.split(":"[0]);
          formattedTime = parseInt(formattedTime);
          formattedTime = formattedTime - 1;

          this.filters.timeRangeSegment1 = {
            segment: 1,
            range: [0, formattedTime],
          };
        } else {
          this.filters.timeRangeSegment1 = {
            segment: 1,
            range: [0, 24],
          };
        }
      }

      if (
        this.meetingInfo.meeting.earliestDeparture.date ===
        moment(this.endDate).format("YYYY-MM-DD")
      ) {
        // console.log('departing on meeting end date');
        if (this.meetingInfo.meeting.earliestDeparture.time !== null) {
          // format time
          let formattedTime = this.meetingInfo.meeting.earliestDeparture.time;
          formattedTime = formattedTime.split(":"[0]);
          formattedTime = parseInt(formattedTime);

          this.filters.timeRangeSegment2 = {
            segment: 0,
            range: [formattedTime, 24],
          };
        } else {
          this.filters.timeRangeSegment2 = {
            segment: 0,
            range: [0, 24],
          };
        }
      }
    },

    /*
    edit() {
      this.display_search = !this.display_search;
      if (this.display_search && this.$app.isMobileVersion()) {
        Toast.open("Edit At Top Of Page");
      }
    },
    dateParse(date) {
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() > 8
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "-" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
      );
    },
    setAvalLogos() {
      let items = this.items;
      let carriersList = [];
      this.avalLogos = [];
      for (let i = 0; i < items.length; i++) {
        var carrier;
        if (!items[i].airlineCode) {
          carrier = "";
        } else {
          carrier = items[i].airlineCode;
        }
        if (!carriersList.includes(carrier) && carrier != "") {
          carriersList.push(carrier);
          // console.log(carrier);
          var myHeaders = new Headers();
          myHeaders.append(
            "Cookie",
            "__cfduid=da51cfb83461564e9f1885a4431d640d41598469194"
          );

          var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };

          fetch(this.$helpers.airlineLogo(carrier, 350, 100), requestOptions)
            .then((response) => response.text())
            .then((result) => this.avalLogos.push(result))
            .catch((error) => console.log("error", error));
        }
      }

      return carriersList;
    },
    */
  },
  watch: {
    // watch filters
    /*
    unusedTicketsOnly() {
      if (this.filters.unusedTicketsOnly) {
        this.filters.selectedAirlines = this.unusedTickets;
        //this.highlightedFilters.unusedTickets = true;
      } else {
        this.filters.selectedAirlines = [];
        //this.highlightedFilters.unusedTickets = false;
      }
    },
    */
    //update price range after new items are loaded
    items() {
      this.filters.minPrice = this.minPrice;
      this.filters.maxPrice = this.maxPrice;
    },
  },
  created() {
    this.TRIP_ONE_WAY = 0;
    this.TRIP_ROUNDTRIP = 1;
    this.TRIP_MULTI_CITY = 2;
    this.ARRIVAL_TIME = 1;
    this.DEPARTURE_TIME = 0;
  },
  mounted() {
    //show preferred vendor results first
    if (this.preferredVendors.length > 0) {
      this.filters.sortOrder = "Preferred Vendors";
    }
  },
  updated() {
    /*
    //reset price filters on re-render
    if (this.maxPrice > 0){     
        this.filters.minPrice = this.minPrice
        this.filters.maxPrice = this.maxPrice
    }
    */
  },
};
</script>

<style lang="scss" scoped>
.scroller {
  height: 100%;
}
.field {
  border-radius: 5px;
  width: 800px;
}
.centered {
  margin: auto auto auto 16rem;
}
.end-divider {
  border: 1px dashed #ddddde;
  margin: 10px 0;
}
</style>
